/**
 * Whether a numeric id is a REAL one: a positive integer. Used for BOTH the tenant id and
 * the location numeric id, which is why the name says neither.
 *
 * Every `/payments/*` route — including `/payments/trx/paypage/init`, the one
 * this app calls to mint a card-field session — names its restaurant with a
 * positive integer. The POS keyed-entry launch reads the pair from its query
 * string with `Number(...)`, and `Number(null)` is `0`, which `Number.isFinite`
 * happily accepts: a launch with no restaurant used to mint (or try to) against
 * restaurant 0. A non-positive id is refused before any request is made.
 */
export function isPositiveIntegerId(value: unknown): value is number {
    return typeof value === 'number' && Number.isInteger(value) && value >= 1;
}

/** Operator-facing refusal, shared by the page and the card form. */
export const MISSING_LOCATION_CONTEXT =
    "This payment form was opened without its restaurant. Close it and try again.";
